import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/pages/event/welcome-popup.webp")